export default __webpack_public_path__ + "static/media/food2.bfddb9c6.png";